(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-video-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';
      const track = section.querySelector('[data-customer-video-track]');
      const cards = Array.from(section.querySelectorAll('[data-customer-video-card]'));
      const previous = section.querySelector('[data-customer-video-previous]');
      const next = section.querySelector('[data-customer-video-next]');
      const toggle = section.querySelector('[data-customer-video-toggle]');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const interval = Math.max(4000, Number(section.dataset.interval) || 6000);
      let automatic = section.dataset.autoplay === 'true' && !prefersReducedMotion.matches;
      let inView = false;
      let timer;
      let scrollFrame;

      if (!track || cards.length === 0) return;

      const cardPosition = (card) => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;

      const activeIndex = () => cards.reduce((best, card, index) => {
        const distance = Math.abs(cardPosition(card) - track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;

      const playActive = () => {
        const current = activeIndex();
        cards.forEach((card, index) => {
          const video = card.querySelector('[data-customer-video]');
          if (!video) return;
          if (index === current && inView) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };

      const move = (direction) => {
        const current = activeIndex();
        const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
        let destination = (current + direction + cards.length) % cards.length;
        if (direction > 0 && track.scrollLeft >= maximum - 2) destination = 0;
        if (direction < 0 && track.scrollLeft <= 2) destination = cards.length - 1;
        track.scrollTo({ left: Math.min(maximum, cardPosition(cards[destination])), behavior: 'auto' });
        window.setTimeout(playActive, prefersReducedMotion.matches ? 0 : 350);
      };

      const stopTimer = () => {
        window.clearInterval(timer);
        timer = undefined;
      };

      const startTimer = () => {
        stopTimer();
        if (!automatic || !inView || cards.length < 2) return;
        timer = window.setInterval(() => move(1), interval);
      };

      const updateToggle = () => {
        if (!toggle) return;
        toggle.dataset.state = automatic ? 'playing' : 'paused';
        toggle.setAttribute('aria-label', automatic ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
      };

      previous?.addEventListener('click', () => {
        move(-1);
        startTimer();
      });
      next?.addEventListener('click', () => {
        move(1);
        startTimer();
      });
      toggle?.addEventListener('click', () => {
        automatic = !automatic;
        updateToggle();
        startTimer();
      });
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(playActive);
      }, { passive: true });
      section.addEventListener('mouseenter', stopTimer);
      section.addEventListener('mouseleave', startTimer);
      section.addEventListener('focusin', stopTimer);
      section.addEventListener('focusout', startTimer);

      const observer = new IntersectionObserver((entries) => {
        inView = entries[0]?.isIntersecting ?? false;
        if (inView) {
          playActive();
          startTimer();
        } else {
          stopTimer();
          cards.forEach((card) => card.querySelector('[data-customer-video]')?.pause());
        }
      }, { threshold: .25 });
      observer.observe(section);
      prefersReducedMotion.addEventListener('change', () => {
        if (prefersReducedMotion.matches) automatic = false;
        updateToggle();
        startTimer();
      });
      updateToggle();
      playActive();
      startTimer();
    };

    document.querySelectorAll('[data-customer-video-section]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-customer-video-section]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
